import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Image,
  Flex,
  Box,
  Button,Text
} from '@chakra-ui/react'
import { DrawerContents } from './DrawerContents';
import {DrawerHead} from './DrawerHead'
import React,{useState} from 'react'
import { RiCloseCircleLine } from 'react-icons/ri'
export default function Order({ item,phn,msg }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
 const [details, setDetails] = useState(false);
 const [ parcel, setParcel ] = useState(false);
  return (
    <>
      <Button
        ref={btnRef}
        variant="link"
        height="3.0625rem"
        borderRadius="10px 10px 0px 0px"
        fontSize="14px"
        color="text.300"
        lineHeight="17px"
        _hover={{
          textDecoration: 'none'
        }}
        onClick={onOpen}>
        View
      </Button>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={btnRef} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <Flex
            flexDir="column"
            height={!details ? '87.875rem' : '95rem'}
            overflow="scroll"
            bg="rgba(7, 5, 41, 0.03)">
            <Flex flexDir="column">
              <DrawerHead item={item} phn={phn} msg={msg} onClose={onClose} />
            </Flex>

            <Flex flexDir="column" height="72.25rem" borderRadius="20px" mt="2rem" bg="#fff">
              <DrawerContents details={details} setDetails={setDetails} parcel={parcel} setParcel={setParcel} />
            </Flex>
          </Flex>
        </DrawerContent>
      </Drawer>
    </>
  )
}